module.exports = __webpack_public_path__ + "img/edit-purple.8611506d.svg";